var React = require('react');

function Blender (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M328 288a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h114.18l17.46-64H328a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h140.36l17.46-64H328a8 8 0 0 1-8-8V72a8 8 0 0 1 8-8h166.55L512 0H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h103.27l8.73 96h256l17.45-64zM64 192V64h69.82l11.64 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 384H160a64 64 0 0 0-64 64v32a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-32a64 64 0 0 0-64-64zm-128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm40-288h131.64l8.72-32H328a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0 96h105.46l8.72-32H328a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-224a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h157.81l8.73-32z","className":"fa-primary","key":2})]);
}

Blender.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Blender;

Blender.default = Blender;
